<template>
    <span class="btn-delete hover-effect"
       @click.stop="removeBookmark"
    ></span>
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, nextTick}  from "vue";
    import {useBookmark}  from "@/modules/reader/bookmark/bookmark";

    export default {
        props: {
           index:Number,
        },
        setup(props, context) {

            const {deleteBookmark} = useBookmark();

            const removeBookmark = (e) =>{
                e.preventDefault();
                e.stopPropagation();
                deleteBookmark(props.index)
            }

            return {
                removeBookmark
            }
        }

    }

</script>

<style scoped lang="scss">

    .btn-delete {
        background:url("~images/btn_delete.svg") 0 0 no-repeat;
        background-size:20px 20px;
        width:20px;
        height:20px;
    }

</style>

